import React from 'react'
import { Link } from 'react-router-dom'
import { Stepper } from 'react-form-stepper';


function ClientComplete() {
    return (
        <div>

            <div className='stepper-div1'>
                {/* <Stepper activeStep={3} steps={[{ label: 'Personal Detail' }, { label: 'Services' }, { label: 'Complete' }]} styleConfig={{
                    activeBgColor: '#485CE1',
                    activeTextColor: '#fff',
                    inactiveBgColor: '#fff',
                    inactiveTextColor: '#3033B5',
                    completedBgColor: '#2729a1',
                    completedTextColor: '#fff',
                    size: '3em'

                }} className={'stepper'}
                    stepClassName={'stepper__step'}>
                </Stepper> */}

                <div className='stepper-main-div1'>
                    <div className='stepper-main-div2'>
                        <div className='stepper-main-div3'>
                            <button className='stepper-main-btn1-complete'><span>1</span></button>
                            <div className='stepper-main-div4'>
                                <span>Personal Detail</span>
                            </div>
                        </div>
                    </div>

                    <div className='stepper-main-div2'>
                        <div className='stepper-main-line2' ><span></span></div>
                        <div className='stepper-main-div3'>
                            <button className='stepper-main-btn1-complete'><span>2</span></button>
                            <div className='stepper-main-div4'>
                                <span>Tax Detail</span>
                            </div>
                        </div>
                    </div>

                    <div className='stepper-main-div2'>
                        <div className='stepper-main-line2' ><span></span></div>
                        <div className='stepper-main-div3'>
                            <button className='stepper-main-btn1-complete'><span>3</span></button>
                            <div className='stepper-main-div4'>
                                <span>Complete</span>
                            </div>
                        </div>
                    </div>
                </div>


                <div className='thank-you-div-11 text-center'>
                    <h1 className='thank-you-text-11'>Thank You</h1>
                    <div className="mt-5 contact-us-btn-div2 justify-content-center">
                        <Link
                            to="/"
                            className="contactus-form-btn4 d-flex justify-content-center align-items-center"
                        >
                            Back To Home
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClientComplete
